const options = {
  5: "bg-indigo-700/5",
  10: "bg-indigo-700/10",
  25: "bg-indigo-700/25",
  50: "bg-indigo-700/50",
  75: "bg-indigo-700/75",
  90: "bg-indigo-700/90",
  100: "bg-indigo-700",
};

const from = {
  5: "from-indigo-700/5",
  10: "from-indigo-700/10",
  25: "from-indigo-700/25",
  50: "from-indigo-700/50",
  75: "from-indigo-700/75",
  90: "from-indigo-700/90",
  100: "from-indigo-700",
};

export default function getBackgroundIndigo700(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
